/* unplugin-vue-components disabled */import script from "./BaseCount.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCount.vue?vue&type=script&setup=true&lang=js"

import "./BaseCount.vue?vue&type=style&index=0&id=7770574c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7770574c"]])

export default __exports__